import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { ChatListWrapper } from './chat-list/ChatList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'User Management',
    path: '/chats',
    isSeparator: false,
    isActive: false,
  },
 
]

const ChatPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        {/* <Route
          path='chats'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>All Chats</PageTitle>
              <ChatListWrapper />
            </>
          }
        /> */}
      </Route>
      <Route index  element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>All Chats</PageTitle>
              <ChatListWrapper />
            </>
          } />
    </Routes>
  )
}

export default ChatPage
